import React, { useCallback } from 'react';
import { View } from 'react-native';
import {
  Banner,
  Button,
  ContractSellerButton,
  Footer,
  KeyboardScreenContainer,
  ProtectionResumeItemCard,
  ServicePriceCard,
  Text,
} from '~/components';
import { isWeb } from '~/utils/device';
import INSURANCES from '~/utils/insurance';
import { formatMoney } from '~/utils';
import { MarisaAppUtils } from '~/utils/MarisaAppUtils';
import {
  ASSURANT_WEBSITE,
  INCOME_PROTECTION_ACCESSION_TERMS_LINK,
} from '~/utils/url';
import { GENERAL_CONDITIONS_LINK } from '~/scenes/IncomeProtection/constants';
import { incomeProtectionResumeItems } from '~/utils/services';
import { useCheckout, useIncomeProtectionForm } from '~/stores';
import type { StepComponentProps } from '~/components/StepsForm';

const INSURANCE_TYPE = 'income-protection';

const IncomeProtectionContractResume: React.FC<StepComponentProps> = ({
  onContinue,
}) => {
  const { setInsuranceFormData, setContractSeller } = useCheckout();
  const { form } = useIncomeProtectionForm();

  const insuranceInfos = INSURANCES.find(
    (insurance) => insurance.type === INSURANCE_TYPE
  );

  const handleSetInsuranceFormData = useCallback(() => {
    setInsuranceFormData(form);
  }, [form, setInsuranceFormData]);

  const handleContinue = useCallback(() => {
    handleSetInsuranceFormData();

    setContractSeller(null);

    onContinue?.();
  }, [handleSetInsuranceFormData, onContinue, setContractSeller]);

  if (!insuranceInfos) return null;

  return (
    <KeyboardScreenContainer
      footer={
        <View className="flex xl:hidden">
          <Footer
            onSubmit={handleContinue}
            buttonLabel="CONTINUAR PARA PAGAMENTO"
          />
        </View>
      }
    >
      <View className="flex-1 container mx-auto xl:flex-row xl:pt-12 xl:pb-24">
        <Banner type="income-protection" />

        <View className="mt-8 xl:mt-0 px-6 flex-1 xl:ml-24">
          <Text className="text-lg text-gray-600">Resumo da contratação</Text>

          <Text className="text-xs text-primary-600 mb-6">
            Proteção Perda de Renda
          </Text>

          <ServicePriceCard value={formatMoney(insuranceInfos.value ?? 0)} />

          {incomeProtectionResumeItems.map((item, index) => (
            <ProtectionResumeItemCard data={item} key={index} />
          ))}

          {!MarisaAppUtils.isTotem() && (
            <Text className="text-xs text-gray-400 text-center mt-4">
              Este seguro é administrado pela{' '}
              <Text
                className="text-primary-600 text-xs font-medium"
                onPress={() => MarisaAppUtils.openUrl(ASSURANT_WEBSITE)}
              >
                Assurant
              </Text>
              .
            </Text>
          )}
          <Text className="text-xs text-gray-400 text-center">
            Condições gerais do Proteção Perda de Renda:{' '}
            <Text
              className="text-primary-600 text-xs font-medium"
              onPress={() => MarisaAppUtils.openUrl(GENERAL_CONDITIONS_LINK)}
            >
              Consulte
            </Text>
          </Text>
          <Text className="text-xs text-gray-400 text-center mb-8">
            Termos de adesão:{' '}
            <Text
              className="text-primary-600 text-xs font-medium"
              onPress={() =>
                MarisaAppUtils.openUrl(INCOME_PROTECTION_ACCESSION_TERMS_LINK)
              }
            >
              Consulte aqui
            </Text>
          </Text>

          <ContractSellerButton
            type={INSURANCE_TYPE}
            beforeNavigate={handleSetInsuranceFormData}
          />

          {isWeb && (
            <View className="flex-1 justify-end hidden xl:flex mt-8">
              <Button className="w-full" onPress={handleContinue}>
                CONTINUAR PARA PAGAMENTO
              </Button>
            </View>
          )}
        </View>
      </View>
    </KeyboardScreenContainer>
  );
};

export default IncomeProtectionContractResume;
